  // import { useEffect, useRef, useState } from "react";
  // import { Dropdown } from "primereact/dropdown";
  // import { InputText } from "primereact/inputtext";
  // import { Button } from "primereact/button";
  // import { Toast } from "primereact/toast";
  // import UserAddressService from "../../services/useraddress/useraddress.service";
  // import { DistrictModel } from "../../models/district-model";

  // interface AddingNewSubdistrictProps {
  //   onSuccess?: () => void;
  // }

  // const AddingNewSubdistrict = ({ onSuccess }: AddingNewSubdistrictProps) => {
  //   const [districts, setDistricts] = useState<DistrictModel[]>([]);
  //   const [selectedDistrictId, setSelectedDistrictId] = useState<string | null>(null);
  //   const [newSubdistrictName, setNewSubdistrictName] = useState<string>("");
  //   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  //   const toast = useRef<Toast>(null);
    
  //   useEffect(() => {
  //     const loadDistricts = async () => {
  //       try {
  //         const response = await UserAddressService.getDistricts(1, 100);
  //         setDistricts(response.districts || []);
  //       } catch (error) {
  //         toast.current?.show({
  //           severity: "error",
  //           summary: "Error",
  //           detail: "Failed to load districts",
  //         });
  //       }
  //     };
  //     loadDistricts();
  //   }, []);

  //   const handleAddSubdistrict = async () => {
  //     if (!selectedDistrictId || !newSubdistrictName.trim()) {
  //       toast.current?.show({
  //         severity: "warn",
  //         summary: "Missing Fields",
  //         detail: "Please select a district and enter a subdistrict name",
  //       });
  //       return;
  //     }
  //     setIsSubmitting(true);

  //     try {
  //       const response = await UserAddressService.addNewSubDistrict({
  //         stateSubdistrict: newSubdistrictName,
  //         districtsId: selectedDistrictId,
  //       });

  //       if (response?.id) {
  //         toast.current?.show({
  //           severity: "success",
  //           summary: "Subdistrict Added",
  //           detail: `${newSubdistrictName} was added successfully!`,
  //           life: 2000,      
  //         });
  //         setNewSubdistrictName("");
  //         setSelectedDistrictId(null);
  //         if (onSuccess) {
  //           setTimeout(onSuccess, 500);
  //         }
  //       } else {
  //         toast.current?.show({
  //           severity: "error",
  //           summary: "Failed",
  //           detail: "Unable to add subdistrict or it already exists.",
  //         });
  //       }
  //     } catch (error) {
  //       toast.current?.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: "An error occurred while adding the subdistrict.",
  //       });
  //     } finally {
  //       setIsSubmitting(false);
  //     }
  //   };

  //   return (
  //     <>
  //       <Toast ref={toast} position="top-center" />

  //       <div className="flex flex-column md:flex-row">
  //         <div className="col-12 mt-2">
  //           <div className="p-fluid formgrid grid">
  //             <div className="field col-12 md:col-6">
  //               <label htmlFor="district" className="bold">Select District</label>
  //               <Dropdown
  //                 id="district"
  //                 value={selectedDistrictId}
  //                 onChange={(e) => setSelectedDistrictId(e.value)}
  //                 options={districts}
  //                 optionLabel="districtName"
  //                 optionValue="districtId"
  //                 placeholder="Select district"
  //                 filter
  //                 filterBy="districtName"
  //                 showClear
  //                 resetFilterOnHide={true}
  //                 disabled={isSubmitting}
  //               />
  //             </div>

  //             <div className="field col-12 md:col-6">
  //               <label htmlFor="subdistrictName">Subdistrict Name</label>
  //               <InputText
  //                 id="subdistrictName"
  //                 value={newSubdistrictName}
  //                 onChange={(e) => setNewSubdistrictName(e.target.value)}
  //                 placeholder="Enter subdistrict name"
  //                 disabled={isSubmitting}
  //               />
  //             </div>
  //           </div>

  //           <div className="col-12 flex justify-content-end mt-3">
  //             <Button
  //               label="Save"
  //               icon="pi pi-check"
  //               className="p-button-success"
  //               onClick={handleAddSubdistrict}
  //               loading={isSubmitting}
  //               disabled={isSubmitting}
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // };

  // export default AddingNewSubdistrict;
  import React, { useEffect, useState } from 'react';
  import { Dialog } from 'primereact/dialog';
  import { InputText } from 'primereact/inputtext';
  import { Button } from 'primereact/button';
  import { Toast } from 'primereact/toast';
  import { Dropdown } from 'primereact/dropdown';
  import { useFormik } from 'formik';
  import { useTranslation } from 'react-i18next';
  import UserAddressService from '../../services/useraddress/useraddress.service';
  import { DistrictModel } from '../../models/district-model';
  
  interface AddSubdistrictProps {
    showDialog: boolean;
    dialogHeader: string;
    onClose: () => void;
  }
  
  const AddSubdistrict: React.FC<AddSubdistrictProps> = ({
    showDialog,
    dialogHeader,
    onClose,
  }) => {
    const { t } = useTranslation();
    const [districts, setDistricts] = useState<DistrictModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [filterValue, setFilterValue] = useState('');
    const toast = React.useRef<Toast>(null);
  
    // Fetch districts when filter value changes
    useEffect(() => {
      const timer = setTimeout(() => {
        fetchDistricts(filterValue);
      }, 300);
      return () => clearTimeout(timer);
    }, [filterValue]);
  
    // Fetch districts from the API
    const fetchDistricts = async (keyword: string = '') => {
      try {
        setLoading(true);
        const response = await UserAddressService.getAllDistricts({ search: keyword });
        setDistricts(response || []);
      } catch (error) {
        showMessage('error', t('error'), t('failedToLoadDistricts'));
        setDistricts([]);
      } finally {
        setLoading(false);
      }
    };
  
    // Show toast message
    const showMessage = (
      severity: 'success' | 'error',
      summary: string,
      detail: string
    ) => {
      toast.current?.show({ severity, summary, detail });
    };
  
    // Formik for handling form submission
    const formik = useFormik({
      initialValues: {
        districtId: '',
        subdistrictName: '',
      },
      validate: (data) => {
        const errors: Record<string, string> = {};
        if (!data.districtId) errors.districtId = 'District Required';
        if (!data.subdistrictName) errors.subdistrictName = 'Subdistrict Name Required';
        return errors;
      },
      onSubmit: async (data, { resetForm }) => {
        try {
          const payload = {
            SubDistrictName: data.subdistrictName,
            DistrictID: data.districtId,
          };
          const response = await UserAddressService.addNewSubDistrict1(payload);
  
          if (response?.isSuccess) {
            showMessage('success', t('Success'), t('Subdistrict Added Successfully'));
            setTimeout(() => {
              onClose();
              resetForm();
            }, 1000);
          } else {
            showMessage('error', t('error'), t('Subdistrict Already Exists'));
          }
        } catch (error) {
          showMessage('error', t('error'), t('Error Creating Subdistrict'));
        }
      },
    });
  
    // Handle dialog close and reset form
    const handleClose = () => {
      onClose();
      formik.resetForm();
      setFilterValue('');
    };
  
    return (
      <Dialog
        visible={showDialog}
        className="quickview w-50"
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        modal
        onHide={handleClose}
        closable
        header={<div className="text-lg font-bold">{t('Add New Subdistrict')}</div>}
      >
        <h5 className="border-round order-top-color p-2">{t('Add New Subdistrict')}</h5>
        <br />
  
        <div className="flex flex-wrap">
          <div className="w-full mb-3 px-3">
            <div className="field">
              <label htmlFor="districtId" className="label-semi-bold">
                {t('District')} <span className="required">*</span>
              </label>
              <br />
              <Dropdown
                id="districtId"
                name="districtId"
                value={formik.values.districtId}
                onChange={(e) => {
                  if (e.value !== null) {
                    formik.setFieldValue('districtId', e.value);
                  }
                }}
                options={districts.length > 0 ? districts : [{ districtName: 'No options available', districtId: null }]}
                optionLabel="display"
                optionValue="districtId"
                placeholder={t('Select District')}
                className={formik.errors.districtId ? 'p-invalid' : ''}
                style={{ width: '100%' }}
                filter
                filterBy="districtName"
                showClear
                onFilter={(e) => setFilterValue(e.filter)}
                filterPlaceholder={t('Search districts...')}
                emptyFilterMessage={t('No districts found')}
              />
              <br />
              {formik.errors.districtId && (
                <small className="p-error">{formik.errors.districtId}</small>
              )}
            </div>
          </div>
  
          <div className="w-full mb-3 px-3">
            <div className="field">
              <label htmlFor="subdistrictName" className="label-semi-bold">
                {t('Subdistrict Name')} <span className="required">*</span>
              </label>
              <br />
              <InputText
                id="subdistrictName"
                name="subdistrictName"
                value={formik.values.subdistrictName}
                onChange={formik.handleChange}
                onKeyDown={(e) => {
                  if (!/^[a-zA-Z ]$/.test(e.key) && e.key !== 'Backspace') {
                    e.preventDefault();
                  }
                }}
                placeholder={t('Enter Subdistrict Name')}
                className={formik.errors.subdistrictName ? 'p-invalid' : ''}
                style={{ width: '100%' }}
              />
              <br />
              {formik.errors.subdistrictName && (
                <small className="p-error">{formik.errors.subdistrictName}</small>
              )}
            </div>
          </div>
        </div>
  
        <div className="text-right mt-4">
          <Button
            label={t('Save')}
            onClick={() => formik.handleSubmit()}
            className="bg-green-700 text-white"
            disabled={loading}
          />
        </div>
  
        <Toast ref={toast} />
      </Dialog>
    );
  };
  
  export default AddSubdistrict;